import { Play } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = {
  url: string
  fileName: string
  className?: string
}

/** first frame as the poster, drawn by the browser rather than rendered by us.
 *  preload='metadata' pulls only the header, and the #t=0.1 fragment is what
 *  makes a frame paint at all -- without it most browsers show a black box
 *  until play. the fragment is not part of the presigned signature. */
export function VideoThumbnail({ url, fileName, className }: Props) {
  return (
    <div className={cn('relative size-full bg-black', className)}>
      <video
        src={`${url}#t=0.1`}
        preload='metadata'
        muted
        playsInline
        aria-label={fileName}
        className='size-full object-cover'
      />
      <span className='absolute inset-0 flex items-center justify-center'>
        <span className='flex size-9 items-center justify-center rounded-full bg-black/55 text-white'>
          <Play className='size-4 fill-current' />
        </span>
      </span>
    </div>
  )
}
